document.addEventListener('DOMContentLoaded', function () {

    const buttons = document.querySelectorAll('.tabs_button');
    const contents = document.querySelectorAll('.tabs_content');
    const select = document.querySelector('.tabs_select');
    if (!buttons.length || !contents.length) return;

    function activateTab(tabId) {
        // reset
        buttons.forEach(btn => btn.classList.remove('is-active'));
        contents.forEach(content => content.classList.remove('is-active'));

        // activate content
        const activeContent = document.getElementById(tabId);
        if (activeContent) activeContent.classList.add('is-active');

        // activate button
        const activeBtn = document.querySelector(`[data-tab="${tabId}"]`);
        if (activeBtn) activeBtn.classList.add('is-active');

        // sync select
        if (select) select.value = tabId;
    }

    // CLICK boutons
    buttons.forEach(btn => {
        btn.addEventListener('click', function () {
            activateTab(this.dataset.tab);
        });
    });

    // CHANGE select
    if (select) {
        select.addEventListener('change', function () {
            activateTab(this.value);
        });
    }

});